import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconSquare = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-square" data-icon="icon-square" aria-hidden="true" {...props} ref={ref}><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/></svg>);
});

IconSquare.displayName = 'IconSquare';
